import moment from 'moment';
import ReactDOM from 'react-dom/client';

const dec2StrLat = (decLatitude: number): string => {
  let intDegree: number;
  let convdetik: number;
  let decMinute: number;
  let decSecond: string | number;
  let strLatitude: string = 'N';

  if (decLatitude < 0) {
    strLatitude = 'S';
    decLatitude = decLatitude * -1;
  }

  intDegree = Math.floor(decLatitude);
  convdetik = (decLatitude - intDegree) * 3600;
  decMinute = Math.floor(convdetik / 60);
  decSecond = convdetik - decMinute * 60;
  decSecond = (decSecond as number).toFixed(2);
  strLatitude =
    strLatitude +
    ' ' +
    String(intDegree) +
    '\xB0' +
    String(decMinute) +
    "' " +
    String(decSecond) +
    "''";

  return strLatitude;
};

const dec2StrLng = (decLongitude: number): string => {
  let intDegree: number;
  let convdetik: number;
  let decMinute: number;
  let decSecond: string | number;
  let strLongitude: string = 'E';

  if (decLongitude < 0) {
    strLongitude = 'W';
    decLongitude = decLongitude * -1;
  }

  intDegree = Math.floor(decLongitude);
  convdetik = (decLongitude - intDegree) * 3600;
  decMinute = Math.floor(convdetik / 60);
  decSecond = convdetik - decMinute * 60;
  decSecond = (decSecond as number).toFixed(2);
  strLongitude =
    strLongitude +
    ' ' +
    String(intDegree) +
    '\xB0 ' +
    String(decMinute) +
    "' " +
    String(decSecond) +
    "''";

  return strLongitude;
};

const rounded = (value: number): number => {
  return Math.round(value * 10000000) / 10000000;
};

const openGoogleMaps = (val: string) => {
  window.open(`https://google.com/maps/place/${val}`);
};

const showAllMarkers = (id: string = '') => {
  let allMarkes = document.querySelectorAll(id ? `.routeClass.vessel-${id}` : '.routeClass');
  for (var i = 0; i < allMarkes.length; i++) {
    //@ts-ignore
    allMarkes[i].style['display'] = 'block';
  }

  let allMarkesTooltip = document.querySelectorAll(
    id ? `.vessel-label.vessel-${id}` : '.vessel-label',
  );
  for (var i = 0; i < allMarkesTooltip.length; i++) {
    //@ts-ignore
    allMarkesTooltip[i].parentElement.style['display'] = 'block';
  }
};

const hideAllMarkers = (id: string = '') => {
  let allMarkes = document.querySelectorAll(id ? `.routeClass.vessel-${id}` : '.routeClass');
  for (var i = 0; i < allMarkes.length; i++) {
    //@ts-ignore
    allMarkes[i].style['display'] = 'none';
  }

  let allMarkesTooltip = document.querySelectorAll(
    id ? `.vessel-label.vessel-${id}` : '.vessel-label',
  );
  for (var i = 0; i < allMarkesTooltip.length; i++) {
    //@ts-ignore
    allMarkesTooltip[i].parentElement.style['display'] = 'none';
  }
};

const addPopup = (content: any, layer: any, options: any = {}) => {
  if (layer && content) {
    // Create real container element
    const container = document.createElement('div');
    // Render React component into that container
    ReactDOM.createRoot(container).render(content);

    const popupOptions = {
      autoClose: true,
      closeOnClick: true,
      ...options,
    };

    if (typeof layer.bindPopup === 'function') {
      layer.bindPopup(container, popupOptions);
    }

    let isPinned = false;
    let isHoverOpening = false;
    let closeTimer: any = null;

    const getPopupOwner = (target: any) => {
      if (target && target._popup) return target;
      if (layer && layer._popup) return layer;
      return target || layer;
    };

    const bindLayerEvents = (target: any) => {
      if (typeof target.bindPopup === 'function' && !target._popup) {
        target.bindPopup(container, popupOptions);
      }

      // CLICK: Open popup at clicked point
      target.on('click', function (this: any, e: any) {
        if (e?.originalEvent) {
          if (typeof (e.originalEvent as any).stopPropagation === 'function') {
            (e.originalEvent as any).stopPropagation();
          }
          if (typeof window !== 'undefined' && (window as any).L?.DomEvent?.stopPropagation) {
            (window as any).L.DomEvent.stopPropagation(e.originalEvent);
          }
        }

        const latlng =
          e?.latlng ||
          (typeof this.getCenter === 'function'
            ? this.getCenter()
            : typeof this.getBounds === 'function'
              ? this.getBounds().getCenter()
              : typeof this.getLatLng === 'function'
                ? this.getLatLng()
                : typeof target.getLatLng === 'function'
                  ? target.getLatLng()
                  : null);

        const owner = getPopupOwner(this);
        if (latlng) {
          owner.openPopup?.(latlng);
        } else {
          owner.openPopup?.();
        }
      });

      // MOUSEOVER: Pointer cursor only (same as WebGL)
      target.on('mouseover', function (this: any) {
        if (this._path) {
          this._path.style.cursor = 'pointer';
        }
        if (this._icon) {
          this._icon.style.cursor = 'pointer';
        }
      });

      // MOUSEOUT: Reset cursor only (same as WebGL)
      target.on('mouseout', function (this: any) {
        if (this._path) {
          this._path.style.cursor = '';
        }
        if (this._icon) {
          this._icon.style.cursor = '';
        }
      });
    };

    bindLayerEvents(layer);
    if (typeof layer.eachLayer === 'function') {
      layer.eachLayer(bindLayerEvents);
    }
  }
};

export interface TimezoneOption {
  value: string;
  label: string;
}

const generateTimezoneOptions = () => {
  const timezoneOptions: TimezoneOption[] = [];
  for (let i = -12; i <= 14; i++) {
    const value = i === 0 ? '0' : i > 0 ? `+${i}` : `${i}`;
    const label = `GMT${value != '0' ? value : ''}`;
    timezoneOptions.push({ value, label });
  }
  return timezoneOptions;
};

const getDateByFormat = (date: string | undefined, format: string) => {
  if (format != '+7' && date) {
    let newDate = moment(date).subtract(7, 'hours');

    const timezone = format || '';
    if (timezone.includes('+')) {
      newDate.add(parseInt(timezone.substring(1)), 'hours');
    } else {
      newDate.subtract(parseInt(timezone.substring(1)), 'hours');
    }

    return `${newDate.format('YYYY-MM-DD HH:mm:ss')} GMT${timezone}`;
  } else {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  }
};

// Palet warna rute yang bernuansa gelap dan kontras tinggi
// Menghindari warna biru/cyan (seperti warna laut) dan hijau/kuning/krem (seperti warna pulau/daratan)
const DARK_ROUTE_PALETTE: { mainColor: string; shadowColor: string }[] = [
  { mainColor: '#1e293b', shadowColor: '#0f172a' }, // Slate 800 (Dark Charcoal)
  { mainColor: '#334155', shadowColor: '#1e293b' }, // Slate 700 (Steel Slate)
  { mainColor: '#4c1d95', shadowColor: '#2e1065' }, // Purple 900 (Deep Royal Purple)
  { mainColor: '#581c87', shadowColor: '#3b0764' }, // Fuchsia 900 (Dark Violet)
  { mainColor: '#881337', shadowColor: '#4c0519' }, // Rose 900 (Dark Wine Crimson)
  { mainColor: '#7f1d1d', shadowColor: '#450a0a' }, // Red 900 (Dark Maroon)
  { mainColor: '#312e81', shadowColor: '#1e1b4b' }, // Indigo 900 (Deep Indigo)
  { mainColor: '#701a75', shadowColor: '#4a044e' }, // Fuchsia 950 (Dark Plum)
  { mainColor: '#27272a', shadowColor: '#18181b' }, // Zinc 800 (Dark Neutral Charcoal)
  { mainColor: '#831843', shadowColor: '#500724' }, // Pink 900 (Dark Berry)
];

const getRandomHexColor = (seed?: string | number) => {
  if (seed !== undefined && seed !== null && seed !== '') {
    const str = String(seed);
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash |= 0;
    }
    const index = Math.abs(hash) % DARK_ROUTE_PALETTE.length;
    return DARK_ROUTE_PALETTE[index];
  }
  const index = Math.floor(Math.random() * DARK_ROUTE_PALETTE.length);
  return DARK_ROUTE_PALETTE[index];
};

// Calculate ship rotation angle based on direction
const getRotationAngle = (polylineRouteData: [any, any][], position: any) => {
  if (!polylineRouteData || polylineRouteData.length < 2) return 0;
  let index = Math.floor(position);
  if (index >= polylineRouteData.length - 1) {
    index = polylineRouteData.length - 2;
  }
  if (index < 0) return 0;

  let lat1 = parseFloat(polylineRouteData[index][0]);
  let lng1 = parseFloat(polylineRouteData[index][1]);
  let lat2 = parseFloat(polylineRouteData[index + 1][0]);
  let lng2 = parseFloat(polylineRouteData[index + 1][1]);

  // If consecutive points are identical, search adjacent points for bearing
  if (lat1 === lat2 && lng1 === lng2) {
    for (let i = index + 1; i < polylineRouteData.length - 1; i++) {
      const nextLat = parseFloat(polylineRouteData[i][0]);
      const nextLng = parseFloat(polylineRouteData[i][1]);
      if (nextLat !== lat1 || nextLng !== lng1) {
        lat2 = nextLat;
        lng2 = nextLng;
        break;
      }
    }
    if (lat1 === lat2 && lng1 === lng2) {
      for (let i = index - 1; i >= 0; i--) {
        const prevLat = parseFloat(polylineRouteData[i][0]);
        const prevLng = parseFloat(polylineRouteData[i][1]);
        if (prevLat !== lat1 || prevLng !== lng1) {
          lat1 = prevLat;
          lng1 = prevLng;
          break;
        }
      }
    }
  }

  const angle = Math.atan2(lng2 - lng1, lat2 - lat1) * (180 / Math.PI);
  return angle;
};

export default {
  getRotationAngle,
  dec2StrLat,
  dec2StrLng,
  rounded,
  openGoogleMaps,
  showAllMarkers,
  hideAllMarkers,
  addPopup,
  generateTimezoneOptions,
  getDateByFormat,
  getRandomHexColor,
};
